import React from 'react';
import fffLogo from './fff-logo.svg';
import styles from './Header.module.css';
import globalStyles from '../../pages/GTBCustomize/gtbCustomize.module.scss';
import FMCProgressBar from '../ProgressNodeBar/FMCProgressBar';
import TimerBar from '../Timer/TimerBar';
import { useSharedContext } from '../../pages/GTBCustomize/ContextProviders/SharedContext';

function FMCHeader(props:{ viewSize:string }) {
  const { viewSize } = props;
  const { loading } = useSharedContext();
  return (
    <>
      <div className={styles.header}>
        {loading && <div className={globalStyles.loading} />}
        <img src={fffLogo} alt="logo" className={styles.fffLogo} data-testid="fff-logo" />
        <div className={styles.gradient} />
        <TimerBar timerStarted viewSize={viewSize} />
        <FMCProgressBar />
        <div className={styles.gradient} />
      </div>
    </>
  );
}

export default FMCHeader;
